import React from 'react';
import { BellOff, Bell, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { TableCell, TableRow } from '@/components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { STATUS, EMAIL_STATUS, WA_STATUS } from './campaignUtils';

export function ContactRow({ r, campaignId, canAct, checked, onToggle, onChange }) {
  const url = `/campaigns/${campaignId}/contacts/${r.id}`;
  const patch = async (body) => {
    try { await api.patch(url, body); onChange(); } catch (e) { toast.error(errText(e, 'No se pudo actualizar')); }
  };
  const remove = async () => {
    if (!window.confirm(`¿Quitar a ${r.church || r.pastor || r.email} de este evento?`)) return;
    try { await api.delete(url); onChange(); } catch (e) { toast.error(errText(e, 'No se pudo eliminar')); }
  };
  const [label, cls] = EMAIL_STATUS[r.email_status] || EMAIL_STATUS.none;

  return (
    <TableRow data-testid={`contact-row-${r.id}`} className={r.unsubscribed ? 'opacity-50' : ''}>
      {canAct && <TableCell><Checkbox checked={checked} onCheckedChange={onToggle} data-testid={`contact-select-${r.id}`} /></TableCell>}
      <TableCell>
        <div className="font-medium">{r.pastor || '—'}</div>
        <div className="text-xs text-[hsl(var(--muted-foreground))]">{r.church || '—'}{r.city ? ` · ${r.city}` : ''}</div>
      </TableCell>
      <TableCell className="text-sm">{r.email || <span className="text-red-300 text-xs">{r.email_invalid ? 'Correo inválido' : 'Sin correo'}</span>}</TableCell>
      <TableCell className="text-sm">
        <div>{r.phone || '—'}</div>
        {r.phone && (
          <span title={r.wa_error || ''} className={`inline-flex mt-1 px-2 py-0.5 rounded-full text-[11px] border ${(WA_STATUS[r.wa_status] || WA_STATUS.none)[1]}`} data-testid={`contact-wa-status-${r.id}`}>
            {(WA_STATUS[r.wa_status] || WA_STATUS.none)[0]}
          </span>
        )}
      </TableCell>
      <TableCell>
        {canAct ? (
          <Select value={r.status} onValueChange={(v) => patch({ status: v })}>
            <SelectTrigger className="h-8 w-52 text-xs" data-testid={`contact-status-${r.id}`}><SelectValue /></SelectTrigger>
            <SelectContent>{Object.entries(STATUS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
          </Select>
        ) : <span className="text-sm">{STATUS[r.status]}</span>}
      </TableCell>
      <TableCell>
        <span title={r.email_error || ''} className={`inline-flex px-2 py-0.5 rounded-full text-[11px] border ${cls}`} data-testid={`contact-email-status-${r.id}`}>
          {r.unsubscribed ? 'Baja' : label}
        </span>
      </TableCell>
      {canAct && (
        <TableCell className="text-right whitespace-nowrap">
          <Button variant="ghost" size="icon" title={r.unsubscribed ? 'Quitar baja' : 'Marcar baja (no enviar más)'}
            onClick={() => patch({ unsubscribed: !r.unsubscribed })} data-testid={`contact-unsub-${r.id}`}>
            {r.unsubscribed ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
          </Button>
          <Button variant="ghost" size="icon" title="Eliminar" onClick={remove} data-testid={`contact-delete-${r.id}`}>
            <Trash2 className="h-4 w-4 text-red-300" />
          </Button>
        </TableCell>
      )}
    </TableRow>
  );
}
